import React, { useEffect, useRef, useState } from 'react';

import axios from 'axios';

import Paper from '@mui/material/Paper';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import CircularProgress from '@mui/material/CircularProgress';
import Backdrop from '@mui/material/Backdrop';
import Typography from '@mui/material/Typography';
import Grid from '@mui/material/Grid';
import Stack from '@mui/material/Stack';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import TableContainer from '@mui/material/TableContainer';
import Pagination from '@mui/material/Pagination';
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';

import moment from 'moment';
import 'moment/locale/ko';
import dayjs from 'dayjs';
import Container from '@mui/material/Container';

const columns = [
  { id: 'rowNumber', label: 'No', minWidth: 30, align: 'center' },
  { id: 'createdAt', label: '접속일자', minWidth: 150, align: 'center' },
  { id: 'pgm', label: '제품', minWidth: 180, align: 'center' },
  { id: 'ver', label: '버전', minWidth: 100, align: 'center' },
  { id: 'cpname', label: '회사', minWidth: 180, align: 'center' },
  { id: 'partname', label: '부서', minWidth: 180, align: 'center' },
  { id: 'username', label: '사용자', minWidth: 100, align: 'center' },
  { id: 'keycode', label: '활성화 코드', minWidth: 100, align: 'center' },
  { id: 'dueDate', label: '만료일', minWidth: 100, align: 'center' },
  { id: 'issueSite', label: '발급처', minWidth: 100, align: 'center' },
  { id: 'isAble', label: '활성화여부', minWidth: 100, align: 'center' }
];

export default function LogMng() {
  const today = dayjs();
  const oneYearAgo = dayjs().subtract(1, 'year');

  const [srchData, setSrchData] = useState({
    isDohwa: true,
    isResearcher: true,
    isAgent: true,
    isDAC: false,
    isBlock: false,
    startDate: oneYearAgo.format('YYYY-MM-DD'),
    endDate: today.format('YYYY-MM-DD')
  });
  const [datas, setDatas] = useState({});
  const [rows, setRows] = useState([]);
  const [pageCnt, setPageCnt] = useState(1);
  const [page, setPage] = useState(1);
  const [offset] = useState(20);
  const [totalCount, setTotalCount] = useState(0); // 전체 건수
  const [open, setOpen] = useState(false);

  const pageCursorRef = useRef({});

  const handleChangeSrch = (e) => {
    setSrchData({ ...srchData, [e.target.id]: e.target.value });
  };

  const handleChangeCheckbox = (e) => {
    setSrchData({ ...srchData, [e.target.name]: e.target.checked });
  };

  const handleRowClick = (data) => () => {
    setDatas(data);
  };

  const handleChangeDate = (name, value) => {
    setSrchData((prev) => ({
      ...prev,
      [name]: value ? dayjs(value).format('YYYY-MM-DD') : ''
    }));
  };

  const buildCursorUpTo = async (targetPage) => {
    if (targetPage <= 1) return;

    const { search, isDohwa, isResearcher, isAgent, isDAC, isBlock } = srchData;

    for (let p = 2; p <= targetPage; p++) {
      if (pageCursorRef.current[p] !== undefined) continue;

      const limit = offset;

      if (p === 2) {
        const paramsForPage1 = { search, isDohwa, isResearcher, isAgent, isDAC, isBlock, limit };
        const res1 = await axios.get('/api/log', { params: paramsForPage1 });
        const data1 = res1.data || {};
        const { nextCursor: nextCursor1 } = data1;

        if (!nextCursor1) {
          pageCursorRef.current[2] = null;
          setPageCnt(Math.max(1, Math.ceil((data1.count || 0) / offset)));
          if (page === 2) {
            setRows([]);
          }
          break;
        }

        pageCursorRef.current[2] = nextCursor1;

        if (p === targetPage && page === 1) {
          setPageCnt(Math.max(1, Math.ceil((data1.count || 0) / offset)));
        }
      } else {
        const prevCursor = pageCursorRef.current[p - 1];
        if (!prevCursor) {
          pageCursorRef.current[p] = null;
          break;
        }

        const paramsForPrevPage = {
          search,
          isDohwa,
          isResearcher,
          isAgent,
          isDAC,
          isBlock,
          limit,
          lastId: prevCursor
        };

        const res = await axios.get('/api/log', { params: paramsForPrevPage });
        const data = res.data || {};
        const { nextCursor } = data;

        if (!nextCursor) {
          pageCursorRef.current[p] = null;
          break;
        }

        pageCursorRef.current[p] = nextCursor;
      }
    }
  };

  const fetchPage = async (targetPage = 1, resetCursor = false) => {
    const { search, isDohwa, isResearcher, isAgent, isDAC, isBlock, startDate, endDate } = srchData;

    setOpen(true);

    if (resetCursor) {
      pageCursorRef.current = {};
    }

    if (targetPage > 1) {
      await buildCursorUpTo(targetPage);
    }

    const limit = offset;
    const params = { search, isDohwa, isResearcher, isAgent, isDAC, isBlock, limit, startDate, endDate };

    if (targetPage > 1) {
      const lastId = pageCursorRef.current[targetPage];
      if (lastId) {
        params.lastId = lastId;
      } else {
        setRows([]);
        setTotalCount(0);
        setPageCnt(1);
        return;
      }
    }

    const response = await axios.get('/api/log', { params });
    if (response.data) {
      const { count = 0, rows: resultRows = [], nextCursor } = response.data;

      setTotalCount(count);
      setPageCnt(Math.max(1, Math.ceil(count / offset)));
      setRows(resultRows);
      if (nextCursor) {
        pageCursorRef.current[targetPage + 1] = nextCursor;
      } else {
        pageCursorRef.current[targetPage + 1] = null;
      }
    }

    setOpen(false);
  };

  const handleChangePage = async (event, value) => {
    setPage(value);
    await fetchPage(value);
  };

  const onClickInit = () => {
    setDatas({});
  };

  const onClickSave = async () => {
    const { userid, username, userpw } = datas;
    const params = { userid, username, userpw };

    try {
      await axios.post(`/api/log`, params);
      await fetchPage(page);
      onClickInit();
    } catch (e) {
      console.log(`insert failed`);
    }
  };

  const onClickModify = async () => {
    const { id, userid, username, isActive } = datas;
    const params = { userid, username, isActive };

    try {
      await axios.patch(`/api/log/${id}`, params);
      await fetchPage(page);
      onClickInit();
    } catch (e) {
      console.log(`insert failed`);
    }
  };

  const onClickDelete = async () => {
    try {
      if (datas.id) {
        await axios.delete(`/api/log/${datas.id}`);
        onClickInit();
        await fetchPage(page);
      }
    } catch (e) {
      console.log(`insert failed`);
    }
  };

  const handleKeyPress = (e) => {
    if (e.key === 'Enter') {
      setPage(1);
      fetchPage(1, true);
    }
  };

  const handleClickSearch = () => {
    setPage(1);
    fetchPage(1, true);
  };

  useEffect(() => {
    fetchPage(1, true);
  }, []);

  return (
    <Paper sx={{ p: 2, display: 'flex', flexDirection: 'column' }}>
      <Typography component="h2" variant="h6" color="primary" gutterBottom>
        로그 관리
      </Typography>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <Stack direction="row" spacing={2}>
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <DatePicker label="시작일" value={dayjs(srchData.startDate)} onChange={(v) => handleChangeDate('startDate', v)} inputFormat="YYYY-MM-DD" renderInput={(params) => <TextField {...params} size="small" />} />

              <DatePicker label="종료일" value={dayjs(srchData.endDate)} onChange={(v) => handleChangeDate('endDate', v)} inputFormat="YYYY-MM-DD" renderInput={(params) => <TextField {...params} size="small" />} />
            </LocalizationProvider>
            <TextField id="search" variant="outlined" size="small" label="검색" value={srchData?.search || ''} onChange={handleChangeSrch} onKeyPress={handleKeyPress} />
            <FormControlLabel control={<Checkbox />} id="isDohwa" name="isDohwa" label="도화 제외" onChange={handleChangeCheckbox} checked={srchData.isDohwa} />
            <FormControlLabel control={<Checkbox />} id="isResearcher" name="isResearcher" label="도화연구원 제외" onChange={handleChangeCheckbox} checked={srchData.isResearcher} />
            <FormControlLabel control={<Checkbox />} id="isAgent" name="isAgent" label="Agent 제외" onChange={handleChangeCheckbox} checked={srchData.isAgent} />
            <FormControlLabel control={<Checkbox />} id="isDAC" name="isDAC" label="DIDAS 발급" onChange={handleChangeCheckbox} checked={srchData.isDAC} />
            <FormControlLabel control={<Checkbox />} id="isBlock" name="isBlock" label="차단 제외" onChange={handleChangeCheckbox} checked={srchData.isBlock} />
            <Button variant="contained" onClick={handleClickSearch}>
              검색
            </Button>
          </Stack>
        </Grid>
        <Grid item xs={12}>
          <TableContainer component={'div'}>
            <Table size="small">
              <TableHead>
                <TableRow>
                  {columns.map((column) => (
                    <TableCell key={column.id} align={column.align} sx={{ minWidth: column.minWidth }}>
                      {column.label}
                    </TableCell>
                  ))}
                </TableRow>
              </TableHead>
              <TableBody>
                {rows.map((row, rowIdx) => (
                  <TableRow key={row.id} onClick={handleRowClick(row)}>
                    {columns.map((col, colIdx) => {
                      if (col.id === 'rowNumber') {
                        const no = totalCount - ((page - 1) * offset + rowIdx);
                        return (
                          <TableCell key={`row${rowIdx}-col${colIdx}`} align={col.align}>
                            {no > 0 ? no : ''}
                          </TableCell>
                        );
                      }
                      if (col.id === 'issueSite') {
                        let issueSite = 'DIDAS';
                        if (row.ActiveCodeMng) {
                          issueSite = 'DAC';
                        } else if (!row.keycode) {
                          issueSite = 'NONE';
                        }
                        return (
                          <TableCell key={`row${rowIdx}-col${colIdx}`} align={col.align}>
                            {issueSite}
                          </TableCell>
                        );
                      }

                      if (col.id === 'isAble') {
                        if (row.DisabledActiveCode) {
                          return (
                            <TableCell key={`row${rowIdx}-col${colIdx}`} align={col.align}>
                              차단
                            </TableCell>
                          );
                        }
                        return (
                          <TableCell key={`row${rowIdx}-col${colIdx}`} align={col.align}>
                            활성화
                          </TableCell>
                        );
                      }

                      return (
                        <TableCell key={`row${rowIdx}-col${colIdx}`} align={col.align}>
                          {col.id === 'createdAt' ? moment(row[col.id]).format('YYYY-MM-DD HH:mm:ss') : row[col.id]}
                        </TableCell>
                      );
                    })}
                  </TableRow>
                ))}
              </TableBody>
            </Table>
            <Container maxWidth="sm" sx={{ mt: 2 }}>
              <Pagination count={pageCnt} page={page} onChange={handleChangePage} showFirstButton showLastButton />
            </Container>
          </TableContainer>
        </Grid>
      </Grid>
      <Backdrop open={open}>
        <CircularProgress />
      </Backdrop>
    </Paper>
  );
}
